import React, { useState, useRef, useCallback } from 'react'
import { Icon } from '@mui/material'
import TouchRipple from '@mui/material/ButtonBase'
import { useLocation } from 'react-router-dom'
import { makeStyles } from '@mui/styles'
import { useEffect } from 'react'
import clsx from 'clsx'
import { twMerge } from 'tailwind-merge'

const useStyles = makeStyles(({ palette, ...theme }) => ({
    expandIcon: {
        transition: 'transform 0.3s cubic-bezier(0, 0, 0.4, 1) 0ms',
        transform: 'rotate(90deg) translateX(8px) translateY(8px)',
    },
    collapseIcon: {
        transition: 'transform 0.3s cubic-bezier(0, 0, 0.4, 1) 0ms',
        transform: 'rotate(0deg) ',
    },
    'expansion-panel': {
        overflow: 'hidden',
        transition: 'max-height 0.3s cubic-bezier(0, 0, 0.2, 1)',
    },
    highlight: {
        background: palette.primary.main,
    },
    navItem: {
        borderRadius: '9999px !important',
        height: '48px !important',
        // color: palette.type === "dark" ? palette.text.secondary : "inherit",
        '&:hover': {
            backgroundColor: palette.action.hover,
        },
        '&:.submenu': {
            backgroundColor: palette.action.hover,
            marginLeft: '0.8rem  !important',
            marginRight: '0.8rem  !important',
        }
    },
    navItemLeft: {
        paddingLeft: '0.8rem  !important',
    },
    navItemActive: {
        backgroundColor: palette.action.selected + ' !important'
    },
    activeColor: {
        color: '#ED636E !important' 
    },
    filterActiveColor: {
        filter: 'invert(48%) sepia(44%) saturate(1580%) hue-rotate(319deg) brightness(101%) contrast(86%)'
    },
    compactNavItem: {
        width: 44,
        overflow: 'hidden',
        // justifyContent: 'center !important',
        '& $itemText': {
            display: 'none',
        },
        '& $itemIcon': {
            display: 'none',
        },
    },
    submenu:{
        marginLeft: '10px',
        marginRight: '10px',
    },
    compactSubmenu: {
        marginLeft: '0 ',
        marginRight: '0',
        
    },
    itemIcon: {},
    itemText: {
        fontSize: '1rem',
        paddingLeft: '2rem',
        color: '#151A25',
        fontWeight: 500,
    },
    bulletIcon: {
        background: '#C4C4C4'//palette.text.secondary,
    },
}))

const MatxVerticalNavExpansionPanel = ({ item, children, mode }) => {
    const [collapsed, setCollapsed] = useState(true)
    const [active, setActive] = useState(false)
    const classes = useStyles()
    const elementRef = useRef(null)
    const componentHeight = useRef(0)
    const { pathname } = useLocation()
    const { name, icon, iconText, urlIcon, badge } = item

    const handleClick = () => {
        componentHeight.current = 0
        calcaulateHeight(elementRef.current)
        setCollapsed(!collapsed)
    }

    const calcaulateHeight = useCallback((node) => {
        if (node.name !== 'child') {
            for (let child of node.children) {
                calcaulateHeight(child)
            }
        }

        if (node.name === 'child') componentHeight.current += node.scrollHeight
        else componentHeight.current += 44 //here 44 is node height
        return
    }, [])

    useEffect(() => {
        if (!elementRef) return

        calcaulateHeight(elementRef.current)
        setCollapsed(true)
        setActive(false)
        // OPEN DROPDOWN IF CHILD IS ACTIVE
        for (let child of elementRef.current.children) {
            if (child.getAttribute('href') === pathname) {
                setCollapsed(false)
                setActive(true)
            }
        }
    }, [pathname, calcaulateHeight])

    return (
        <div className="tw-mt-4">
            <TouchRipple
                className={clsx({
                    'flex justify-between tw-rounded-full w-full  has-submenu compactNavItem whitespace-pre overflow-hidden': true,
                    [classes.navItem]: true,
                    [classes.navItemLeft]: mode !== 'compact',
                    [classes.compactNavItem]: mode === 'compact',
                    [classes.navItemActive]: active,
                    open: !collapsed,
                })}
                onClick={handleClick}
            >
                <div className=" flex items-center">
                    {urlIcon && (
                        <img className={clsx({
                            "tw-ml-2 tw-w-6": true,
                            [classes.filterActiveColor]: active,
                        })} src={urlIcon} alt="icone" />
                    )}
                    {icon && (
                        <Icon className={clsx({
                            "align-middle text-18 w-36 px-4": true,
                            [classes.filterActiveColor]: active,
                        })}>
                            {icon}
                        </Icon>
                    )}
                    {iconText && (
                        <div
                            className={clsx(
                                'w-4 h-4 rounded bg-white ml-5 mr-2',
                                classes.bulletIcon
                            )}
                        ></div>
                    )}
                    <span
                        className={clsx({
                            'align-middle sidenavHoverShow': true,
                            [classes.itemText]: true,
                            [classes.activeColor]: active
                        })}
                    >
                        {name}
                    </span>
                </div>
                {badge && (
                    <div
                        className={clsx(
                            `rounded bg-${item.badge.color} px-1 py-1px`,
                            'sidenavHoverShow',
                            classes.itemIcon
                        )}
                    >
                        {badge.value}
                    </div>
                )}
                <div
                    className={clsx({
                        'item-arrow sidenavHoverShow tw-pr-4': true,
                        [classes.itemIcon]: true,
                        [classes.collapseIcon]: collapsed,
                        [classes.expandIcon]: !collapsed,
                    })}
                >
                    <Icon fontSize="medium" className="align-middle tw-text-azulescuro">
                        chevron_right
                    </Icon>
                </div>
            </TouchRipple>

            <div
                ref={elementRef}
                className={twMerge(
                    clsx({
                        // [classes['expansion-panel']]: true, 'submenu':true, 
                        [classes.submenu]:mode !== 'compact',
                        [classes.compactSubmenu]:mode === 'compact',
                    }),
                    'tw-flex tw-flex-col'
                )}
                style={
                    collapsed
                        ? { maxHeight: '0px' }
                        : { maxHeight: componentHeight.current + 'px' }
                }
            >
                {children}
            </div>
        </div>
    )
}

export default MatxVerticalNavExpansionPanel
